<template>
  <div class="step-location">
    <h2 class="step-location__title">Your garden</h2>

    <v-text-field
      :value="wizardData.name"
      label="Garden name"
      placeholder='e.g. "Balcony de la Plaine"'
      outlined
      dense
      class="mt-2"
      :error-messages="nameError"
      @input="update('name', $event)"
      @blur="touchedName = true"
    />

    <v-text-field
      :value="wizardData.city"
      label="City"
      placeholder='e.g. "Marseille"'
      outlined
      dense
      :error-messages="cityError"
      @input="update('city', $event)"
      @blur="touchedCity = true"
    />

    <div class="field-label">Sun exposure</div>
    <div class="exposition-tiles">
      <div
        v-for="opt in expositionOptions"
        :key="opt.value"
        class="exposition-tile"
        :class="{ 'exposition-tile--selected': wizardData.exposition === opt.value }"
        @click="update('exposition', opt.value)"
      >
        <span class="tile-icon">{{ opt.icon }}</span>
        <span class="tile-label">{{ opt.label }}</span>
      </div>
    </div>

    <div class="container-toggle">
      <span class="toggle-label">🪴 Pots &amp; bags</span>
      <v-switch
        :input-value="!wizardData.container_only"
        hide-details
        dense
        color="primary"
        class="mx-3 my-0"
        @change="update('container_only', !$event)"
      />
      <span class="toggle-label">🌱 In-ground</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepLocation',
  props: {
    wizardData: { type: Object, required: true },
  },
  data() {
    return {
      touchedName: false,
      touchedCity: false,
      expositionOptions: [
        { value: 'full_sun', icon: '☀️',  label: 'Full sun' },
        { value: 'partial',  icon: '🌤',  label: 'Partial' },
        { value: 'shade',    icon: '🌿',  label: 'Shade' },
      ],
    }
  },
  computed: {
    nameError() {
      return this.touchedName && !this.wizardData.name ? ['Required'] : []
    },
    cityError() {
      return this.touchedCity && !this.wizardData.city ? ['Required'] : []
    },
  },
  methods: {
    update(field, value) {
      this.$emit('update:wizardData', { ...this.wizardData, [field]: value })
    },
  },
}
</script>

<style scoped>
.step-location__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a3a2a;
  margin-bottom: 16px;
}
.field-label {
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
}
.exposition-tiles {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
.exposition-tile {
  flex: 1;
  border: 1.5px solid #e0e0d8;
  border-radius: 8px;
  padding: 12px 6px;
  text-align: center;
  cursor: pointer;
  background: #fafaf8;
  transition: border-color 0.15s, background 0.15s;
}
.exposition-tile--selected {
  border-color: #2e7d32;
  background: #f1f8f1;
}
.tile-icon {
  display: block;
  font-size: 1.4rem;
  margin-bottom: 4px;
}
.tile-label {
  font-size: 0.78rem;
  color: #444;
}
.container-toggle {
  display: flex;
  align-items: center;
  border: 1.5px solid #e0e0d8;
  border-radius: 8px;
  padding: 10px 14px;
  background: #fafaf8;
}
.toggle-label {
  font-size: 0.85rem;
  color: #555;
  white-space: nowrap;
}
</style>
